// import axios from 'axios'
import axios from '@/services/axiosInstance'
import { getDataConfig } from '../services/environment'
const TODO_ENV = getDataConfig()
const BASE_URL = TODO_ENV.VUE_APP_API_URL
const API_CHECK_IN = `${BASE_URL}/api/v1/checkin-queue`
const API_ANTRIAN_GENERATE = `${BASE_URL}/api/v1/antrians`
const API_ORDER_LINES = `${BASE_URL}/api/v1/order-lines`
const API_DEVICE_CONFIG = `${BASE_URL}/api/v1/device-config`
const API_MOVE_ANTRIAN = `${BASE_URL}/api/v1/move-queue`
const API_RESERVASIS = `${BASE_URL}/api/v1/reservasis`
const API_CREATE_QUEUE = `${BASE_URL}/api/v1/create-queues`
const API_DATE_SERVER = `${BASE_URL}/api/v1/server-config`
const API_GET_RESERVASI_ORDER = `${BASE_URL}/api/v1/reservasi-orders`
const API_LABEL = `${BASE_URL}/api/v1/labels`
const API_CHANGE_GENERATED_ID = `${BASE_URL}/api/v1/reprint-queue`

export default {
  getAPIDateServer () {
    return axios.get(`${API_DATE_SERVER}`)
  },
  postCreateQueue (body, cancelToken) {
    return axios.post(`${API_CREATE_QUEUE}`, body, { cancelToken })
  },
  getReservasis (params) {
    return axios.get(`${API_RESERVASIS}`, { params })
  },
  moveQueueUnit (body) {
    return axios.post(`${API_MOVE_ANTRIAN}`, body)
  },
  checkInQueue (body) {
    return axios.post(`${API_CHECK_IN}`, body)
  },
  getTicketInfo (generatedId) {
    return axios.get(`${API_ANTRIAN_GENERATE}/${generatedId}`)
  },
  getOrderLines (params) {
    return axios.get(`${API_ORDER_LINES}`, { params })
  },
  getReservasiOrder (params) {
    return axios.get(`${API_GET_RESERVASI_ORDER}`, { params })
  },
  getAllLabels () {
    return axios.get(`${API_LABEL}`)
  },
  postChangeGeneratedId (body) {
    return axios.post(`${API_CHANGE_GENERATED_ID}`, body)
  },
  postConfig (socketId, token) {
    return axios.post(`${API_DEVICE_CONFIG}`, {
      deviceSocketId: socketId
    }, {
      headers: {
        token
      }
    })
  },
  getTicketSocketInfo (generatedId) {
    return new Promise((resolve, reject) => {
      window.socket.emit('GET:ANTRIANS', { params: { generatedId } }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  getReservasiOrderSocket ({ unitId, tanggalKunjungan }) {
    return new Promise((resolve, reject) => {
      window.socket.emit('GET:RESERVASI:ORDERS', { queryParams: { 'unitId.equals': unitId, 'tanggalKunjungan.equals': tanggalKunjungan } }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  chekcInKioskSocket (body) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:CHECKIN-QUEUE', { payload: body }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  getOrderLinesSocket (params) {
    return new Promise((resolve, reject) => {
      window.socket.emit('GET:ORDERLINES', { appendUrl: params.toString() }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  postCreateQueueSocket (body) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:CREATE-TICKET', { payload: body }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  postCreateQueueSocketVerified (body) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:CREATE-TICKET-VERIFIED', { payload: body }, (response) => {
      // window.socket.emit('POST:CREATE-TICKET', { payload: body }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  getReservasisSocket (params) {
    return new Promise((resolve, reject) => {
      window.socket.emit('GET:RESERVASIS', { queryParams: params }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  moveQueueUnitSocket (body) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:MOVE-QUEUE', { payload: body }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  postChangeGeneratedIdSocket (body) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:REPRINT', { payload: body }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  postConfigSocket (socketId, token) {
    return new Promise((resolve, reject) => {
      window.socket.emit('POST:DEVICE-CONFIG', {
        headers: { token },
        payload: { deviceSocketId: socketId }
      }, (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  getAPIDateServerSocket () {
    return new Promise((resolve, reject) => {
      window.socket.emit('SERVER:CONFIG', (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  },
  getAllLabelsSocket () {
    return new Promise((resolve, reject) => {
      window.socket.emit('GET:LABELS', (response) => {
        const status = parseInt(response.status)
        if (status >= 200 && status < 202) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  }
}
